export enum FileErrorCodeEnum {
    POOR_LIGHTING_CONDITIONS = 5004,
    FACE_VIDEO = 5005,
    FACE_IMAGE = 5007,
    LIMIT_UPLOADING = 'Limit for uploading files are exceeded',
}
